import { AuthClient } from "../../client";

export const updateMineral = (data: {}) => {
  return AuthClient().patch(`/common/update-mineral`, data);
};

export const updatePinnedMineral = (data: any) => {
  return AuthClient().patch(`/common/update-pinned-mineral`, data);
};

export const deleteMineral = (id: string | null) => {
  return AuthClient().delete(`/common/delete-mineral/${id}`);
};
